import AudiencePage from './AudiencePage';

const CHAPTERS = [
  {
    num: '01',
    icon: 'self_improvement',
    title: 'Body',
    desc: 'Your brain and body are still wiring themselves until 25. We start with sleep, movement, and simple mind practices that fit real student life — not another thing to fail at.'
  },
  {
    num: '02',
    icon: 'visibility',
    title: 'Truth',
    desc: 'Between comparisons, expectations, and social media, it\'s hard to know what you actually feel. Learn to see your emotions honestly — without filters, yours or anyone else\'s.'
  },
  {
    num: '03',
    icon: 'spa',
    title: 'Soul',
    desc: 'Not religion — connection. Simple practices that build inner steadiness and positive energy when everything outside feels like it\'s moving too fast.'
  },
  {
    num: '04',
    icon: 'hearing',
    title: 'Senses',
    desc: 'How you read a comment, a look, a silence shapes your whole day. Understand your perception — why you see things the way you do — and take the wheel back.'
  }
];

const ForYouth = () => (
  <AudiencePage
    slug="youth"
    eyebrow="For Youth · Ages 15–30"
    title={<>The decade that<br />writes the next fifty.</>}
    intro="The brain is still forming until 25. Identity, career, relationships, and mental health are all set here — often at speeds no one taught you to slow down. Emotional intelligence is the one skill that compounds across all four."
    image="https://images.unsplash.com/photo-1517841905240-472988babdf9?w=1200&q=80&auto=format&fit=crop"
    imageAlt="Young person in a moment of reflection"
    chapters={CHAPTERS}
    quote="Learn your emotions now. Thank yourself for fifty years."
    quoteSub="Talk to us about where you are and where you want to go — we'll shape the practice around your life."
  />
);

export default ForYouth;
